import { render, staticRenderFns } from "./TabelaLog.vue?vue&type=template&id=5601f0de&"
import script from "./TabelaLog.vue?vue&type=script&lang=js&"
export * from "./TabelaLog.vue?vue&type=script&lang=js&"
import style0 from "./TabelaLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports